import React from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeClasses = {
  sm: 'max-w-md',
  md: 'max-w-2xl',
  lg: 'max-w-3xl',
  xl: 'max-w-4xl',
};

export default function Modal({ isOpen, onClose, title, children, size = 'lg' }: ModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <div
          className="fixed inset-0 bg-navy-950/60 backdrop-blur-sm transition-opacity"
          onClick={onClose}
        />
        <div className={`relative w-full ${sizeClasses[size]} rounded-2xl bg-white dark:bg-navy-900 p-6 shadow-2xl border border-navy-200 dark:border-navy-700`}>
          <div className="flex items-center justify-between mb-4 pb-4 border-b border-navy-200 dark:border-navy-700">
            <h3 className="text-lg font-semibold text-navy-900 dark:text-navy-50">{title}</h3>
            <button
              onClick={onClose}
              className="p-2 rounded-lg text-navy-400 hover:text-navy-600 hover:bg-navy-100 dark:hover:text-navy-200 dark:hover:bg-navy-800 transition-all duration-200"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="max-h-[70vh] overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

